import styled from 'styled-components';

export const CheckIconWrapper = styled.span`
  display: flex;
  width: 1.76rem;
  justify-content: center;
`;
